import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CategoriesSider from "../../Components/SideBar/CategoriesSider";
import { CategoryContext, KBContext } from "../../Context";
import { handlePageVisitData } from "../../utils";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { KB_WEBSITE_GAINSIGHT_EVENTS, sendGainsightEvent } from "../../gainSightIntegration";

export default function CategoryList({ focus }) {
  const { categoryList, setSelectedCategory, selectedCategory } = useContext(CategoryContext);
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);
  const { data: { isInternal } } = useContext(KBContext);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const detectSize = () => {
    if (window.innerWidth < 800) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [screenWidth]);

  const navigate = useNavigateWithSearch();
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    navigate(`/${category.slug}`);
    focus();
  };

  useEffect(() => {
    const res = categoryList.find((cat) => cat.slug === pathname.split("/")[1]);
    const category_slug = res?.slug || pathname.split("/")[1] || '';
    const article_slug = pathname.split("/")[2] || '';
    handlePageVisitData(window.location, isInternal, category_slug, article_slug);
    if (res) {
      setSelectedCategory(res);
      if (category_slug && !article_slug) {
        sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_CATEGORY_VIEWED, { category_slug, category_name: res.title });
      }
    }
  }, [pathname, categoryList, setSelectedCategory, isInternal]);

  if (visible) {
    return (
        <CategoriesSider
          categories={categoryList}
          pathname={pathname}
          handleCategoryClick={handleCategoryClick}
        />
    );
  } else {
    return "";
  }
}
